import { DescriptionsFormItem } from '#components';
import { Form, Modal } from '@bedrock/components';
import { useSForm, withFunctionCall } from '@mpc/components';
import React, { useEffect } from 'react';

const LookQuoteRemarkModal = ({ record = {}, ...rest }) => {

  const { form } = useSForm({});

  useEffect(() => {
    form.setFieldsValue(record)
  }, [])
  
  return (
    <Modal
      title={record?.demand_source_supplier_vo?.supplier_name || ''}
      footer={null}
      {...rest}
    >
      <Form form={form}>
        <DescriptionsFormItem
          className='m-b-24'
          items={[
            {
              formItemKey: 'quote_price',
              label: '初次报价',
              componentClass: 'input',
              view: true,
            },
            {
              formItemKey: 'count',
              label: '数量',
              componentClass: 'input',
              view: true,
            },
            {
              formItemKey: 'remark_dto.text',
              label: '报价备注',
              componentClass: 'input',
              view: true,
              span: 2,
            },
            {
              formItemKey: 'remark_dto.files',
              label: '报价备注附件',
              componentClass: 'upload',
              view: true,
              span: 2,
            },
          ]}
        />
      </Form>
    </Modal>
  )
}

export default withFunctionCall(LookQuoteRemarkModal);
